<template>
  <div>
    <navigation fancy :utm="utm" />
    <hero :utm="utm" />

    <div
      v-if="$root.$i18n.locale === 'de' && nextWebinar"
      class="mt-6"
    >
      <banner
        :text="$t('views.banner.2026-02-27.text')"
        :cta="$t('views.banner.cta')"
        :link="nextWebinar.dachLink"
      />
    </div>

    <features />
    <benefits />
    <quote />
    <about />
    <metrics />
    <!-- <counseling /> -->
    <cta :utm="utm" />
    <news />
    <footerNavigation />
  </div>
</template>

<script>
import footerNavigation from "../components/footerNavigation.vue";
import navigation from "../components/navigation.vue";
import about from "../components/sections/about.vue";
import banner from "../components/sections/banner.vue";
import benefits from "../components/sections/benefits.vue";
// import counseling from "../components/sections/counseling.vue";
import cta from "../components/sections/cta.vue";
import features from "../components/sections/features.vue";
import hero from "../components/sections/hero.vue";
import metrics from "../components/sections/metrics.vue";
import news from "../components/sections/news.vue";
import quote from "../components/sections/quote_new.vue";
import { nextWebinar } from "../webinars";

export default {
	name: "index",
	props: {
		utm: Object,
	},
	computed: {
		nextWebinar() {
			return nextWebinar();
		},
	},
	components: {
		navigation,
		banner,
		hero,
		// counseling,
		news,
		about,
		features,
		benefits,
		metrics,
		quote,
		cta,
		footerNavigation,
	},
};
</script>
